
// Application Module Getters
const getters = {
  collection: state => {
    return state.collection
  },
  current: state => {
    return state.current
  },
  fetching: state => {
    return state.fetching
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/application/getters.js